import * as React from "react";
import styles from "./styles.module.scss";

export const VisuallyHidden = React.forwardRef<
    HTMLSpanElement,
    React.HTMLAttributes<HTMLSpanElement>
>(function VisuallyHidden(props, ref) {
    return <span ref={ref} className={styles.visuallyHidden} {...props}></span>;
});
